function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { NjcPopover as g } from "../popover.js";
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as p, nothing as u } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import { LitElement as v } from "../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { ref as b } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/ref.js";
import { customElement as _ } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import y from "../../../packages/web-components/src/components/popover/gator/popover.gator.scss.js";
import P from "../../../packages/web-components/src/components/popover/popover.scss.js";
import E from "../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import k from "../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import { autoUpdate as w, computePosition as O, autoPlacement as S } from "../../../node_modules/.pnpm/@floating-ui_dom@1.7.1/node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
import $ from "../../../packages/web-components/public/styles/gator/gator-global-styles.css.js";
import { KEY_CONSTANTS as l } from "../../../consts/key-constants.js";
import { msg as x } from "../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/install.js";
import "../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/runtime.js";
import { unsafeCSS as h } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var R = Object.getOwnPropertyDescriptor,
  C = function C(t, e, i, r) {
    for (var o = r > 1 ? void 0 : r ? R(e, i) : e, s = t.length - 1, n; s >= 0; s--) (n = t[s]) && (o = n(o) || o);
    return o;
  };
var m = /*#__PURE__*/function (_g) {
  function m() {
    _classCallCheck(this, m);
    return _callSuper(this, m, arguments);
  }
  _inherits(m, _g);
  return _createClass(m, [{
    key: "render",
    value: function render() {
      return p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div\n                ", "\n                id=\"", "\"\n                class=\"gator-popover ", " gator-popover-", "\"\n                aria-label=\"", "\"\n                role=\"dialog\"\n            >\n                ", "\n                ", "\n                ", "\n            </div>\n        "])), b(this._popoverRef), this.popoverId, this._nubbinPositionClass, this.size, this.title, this._closeButtonMarkup, this._bodyMarkup, this._footerMarkup);
    }
  }, {
    key: "_closeButtonMarkup",
    get: function get() {
      return p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            <ngc-icon-button\n                id=\"gator-popover-close\"\n                .ariaLabel=\"", " ", "\"\n                icon-name=\"exit\"\n                size=\"xsmall\"\n                @click=\"", "\"\n                @keydown=\"", "\"\n            ></ngc-icon-button>\n        "])), x("Close"), this.title, this.hidePopover, this._handleKeyDown);
    }
  }, {
    key: "_bodyMarkup",
    get: function get() {
      return p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            <div class=\"gator-popover-body\">\n                <slot name=\"labels\"></slot>\n                <div class=\"gator-popover-body-container\">\n                    ", "\n\n                    <div class=\"gator-popover-body-content\">\n                        <span class=\"gator-popover-body-title\">", "</span>\n                        <slot\n                            id=\"gator-popover-content-slot\"\n                            name=\"content\"\n                        ></slot>\n                    </div>\n                </div>\n            </div>\n        "])), this.iconName ? p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                        <ngc-icon\n                            name=\"", "\"\n                            width=\"24\"\n                            height=\"24\"\n                        ></ngc-icon>\n                    "])), this.iconName) : u, this.title);
    }
  }, {
    key: "_footerMarkup",
    get: function get() {
      return p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            <div class=\"gator-popover-divider\"></div>\n            <div class=\"gator-popover-footer\">\n                ", "\n                <slot name=\"footer\"></slot>\n            </div>\n        "])), this.errorText ? p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<ngc-help-text icon error>", "</ngc-help-text>"])), this.errorText) : u);
    }
  }, {
    key: "_computedPlacement",
    get: function get() {
      return this.placement || this._placement;
    }
  }, {
    key: "_xPositionOffset",
    get: function get() {
      return this._computedPlacement.includes("left") ? -12 + this.xOffset : this._computedPlacement.includes("right") ? 12 + this.xOffset : 0;
    }
  }, {
    key: "_yPositionOffset",
    get: function get() {
      return this._computedPlacement.includes("top") ? -12 + this.yOffset : this._computedPlacement.includes("bottom") ? 12 + this.yOffset : 0;
    }
  }, {
    key: "_nubbinPositionClass",
    get: function get() {
      return {
        "top-start": "gator-popover-nubbin_bottom-start",
        top: "gator-popover-nubbin_bottom-center",
        "top-end": "gator-popover-nubbin_bottom-end",
        "right-start": "gator-popover-nubbin_left-start",
        right: "gator-popover-nubbin_left-center",
        "right-end": "gator-popover-nubbin_left-end",
        "bottom-start": "gator-popover-nubbin_top-start",
        bottom: "gator-popover-nubbin_top-center",
        "bottom-end": "gator-popover-nubbin_top-end",
        "left-start": "gator-popover-nubbin_right-start",
        left: "gator-popover-nubbin_right-center",
        "left-end": "gator-popover-nubbin_right-end"
      }[this._computedPlacement];
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      _superPropGet(m, "connectedCallback", this, 3)([]), this.addTrackedEventListener(this.referenceElement, "keydown", function (t) {
        (t.key === l.SPACE || t.key === l.ENTER) && (t.preventDefault(), t.stopPropagation(), _this.showPopover(!0));
      });
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      var o, s;
      _superPropGet(m, "firstUpdated", this, 3)([]);
      var t = (o = this.shadowRoot) == null ? void 0 : o.querySelector('slot[name="footer"]'),
        e = (s = this.shadowRoot) == null ? void 0 : s.querySelector(".gator-popover-footer"),
        i = !!t && t.assignedNodes().length > 0,
        r = !!this.errorText;
      e && (e.style.display = i || r ? "flex" : "none");
    }
  }, {
    key: "updated",
    value: function updated(t) {
      _superPropGet(m, "updated", this, 3)([t]), t.has("placement") && (this._cleanup && this._cleanup(), this.assignPosition(), this.requestUpdate());
    }
  }, {
    key: "assignPosition",
    value: function assignPosition() {
      var _this2 = this;
      var t = this.referenceElement;
      if (!this._popoverRef || !this._popoverRef.value || !t) return;
      var e = {
          placement: this.placement
        },
        i = {
          middleware: [S({
            allowedPlacements: ["top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-start", "bottom", "bottom-end", "left-start", "left", "left-end"],
            padding: 5
          })]
        },
        o = !!this.placement ? e : i;
      this._cleanup = w(t, this._popoverRef.value, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$O, s, n, a;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this2._popoverRef || !_this2._popoverRef.value || !t)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return O(t, _this2._popoverRef.value, o);
            case 4:
              _yield$O = _context.sent;
              s = _yield$O.x;
              n = _yield$O.y;
              a = _yield$O.placement;
              _this2._placement !== a && (_this2._placement = a, _this2.requestUpdate()), Object.assign(_this2._popoverRef.value.style, {
                left: "".concat(s + _this2._xPositionOffset, "px"),
                top: "".concat(n + _this2._yPositionOffset, "px")
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    }
  }, {
    key: "showPopover",
    value: function showPopover() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      _superPropGet(m, "showPopover", this, 3)([t]), this.addEventListener("keydown", this._handleKeyDown);
    }
  }, {
    key: "hidePopover",
    value: function hidePopover() {
      var i, r;
      _superPropGet(m, "hidePopover", this, 3)([]);
      var t = (i = this.shadowRoot) == null ? void 0 : i.querySelector("#gator-popover-close"),
        e = (r = t == null ? void 0 : t.shadowRoot) == null ? void 0 : r.firstElementChild;
      e == null || e.classList.remove("no-focus-visible");
    }
  }, {
    key: "_handleKeyDown",
    value: function _handleKeyDown(t) {
      var r, o, s, n;
      var i = (t.key === l.SPACE || t.key === l.ENTER) && ((r = t.target) == null ? void 0 : r.id) === "gator-popover-close";
      if ((t.key === l.ESCAPE || i) && (t.preventDefault(), this.hidePopover(), this.referenceElement.focus()), t.key === l.TAB) {
        var _ref2;
        var a = this._getKeyboardFocusableElements(),
          c = (_ref2 = (o = this.shadowRoot) == null ? void 0 : o.activeElement) !== null && _ref2 !== void 0 ? _ref2 : document.activeElement,
          d = a[0],
          f = a[a.length - 1];
        (n = (s = c == null ? void 0 : c.shadowRoot) == null ? void 0 : s.firstElementChild) == null || n.classList.remove("no-focus-visible"), t.shiftKey ? c === d && (t.preventDefault(), t.stopPropagation(), f.focus()) : c === f && (t.preventDefault(), t.stopPropagation(), d.focus());
      }
    }
  }]);
}(g);
m.shadowRootOptions = _objectSpread(_objectSpread({}, v.shadowRootOptions), {}, {
  delegatesFocus: !0,
  mode: "open"
});
m.styles = [h(y), h(P), h(E), h(k), h($)];
m = C([_("ngc-popover")], m);
export { m as NgcPopover };